import { Button, Img, Heading } from "../../components";
import ZFLOCE from "../../components/ZFLOCE";
import React, { Suspense } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";

export default function ProjectsSection() {
  const projects = [
    {
      title: "Aasenar",
      type: "Website Development",
      image: "images/E-1.png",
      backgroundImage: "images/bg-project-1.jpeg",
      backgroundImage2: "images/glass-effect.png",
      projectLink: "https://aaseanar.com/"
    },
    {
      title: "Leadlytics",
      type: "Website Development",
      image: "images/E-2.png",
      backgroundImage: "images/bg-project-2.jpeg",
      projectLink: "https://leadlyticslabs.com/"
    },
    {
      title: "Dream PG",
      type: "Mobile App Development",
      image: "images/E-3.png",
      backgroundImage: "images/bg-dream-pg.png",
      projectLink: "https://dreampg.co.in/"
    },
    {
      title: "ZoomInfo",
      type: "Website Development",
      image: "images/E-4.png",
      backgroundImage: "images/bg-project-3.jpeg",
      backgroundImage2: "images/glass-effect-2.png",
      projectLink: "https://www.zoominfo.com/?gad_source=1&gclid=CjwKCAiAzba9BhBhEiwA7glbam0gLgJ-JOdeIbgSUi7y5bE0mGfgP5kEbLGK6sgBjWrfNGwImknT8xoC_CcQAvD_BwE"
    },
  ];

  const isMobileOrTablet = useMediaQuery({ query: "(max-width: 1024px)" });

  const navigate = useNavigate();

  const handleViewAllWork = () => {
    navigate('/all-projects');
  };

  return (
    <div className="flex items-center justify-center bg-[url('/public/images/bg-3.png')] bg-cover bg-no-repeat py-[100px] sm:py-5">
      <div className="container flex flex-col items-center gap-12 sm:px-[20px] lg:px-[50px] xl:px-[200px]">
        {/* Section Heading */}
        <Heading
          as="p"
          className="text-[90px] font-semibold uppercase text-gray-950 sm:text-[48px]"
        >
          Projects
        </Heading>

        {/* Projects Grid */}
        <div className="grid grid-cols-2 gap-8 md:grid-cols-1 sm:grid-cols-1 z-0">
          {isMobileOrTablet ? (
            <Swiper
              spaceBetween={20}
              slidesPerView={1}
              pagination={{ clickable: true }}
              style={{ height: 'auto', width: '100%', paddingBottom: "35px" }}
              modules={[Pagination]}
            >
              {projects.map((project, index) => (
                <SwiperSlide key={"journeyList" + index}>
                  <ZFLOCE
                    key={index}
                    projectTitle={project.title}
                    projectType={project.type}
                    imageSrc={project.image}
                    backgroundImage={project.backgroundImage}
                    backgroundImage2={project.backgroundImage2}
                    projectLink={project.projectLink}
                    className="hover:shadow-xl"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <Suspense fallback={<div>Loading feed...</div>}>
              {projects.map((project, index) => (
                <ZFLOCE
                  key={index}
                  projectTitle={project.title}
                  projectType={project.type}
                  imageSrc={project.image}
                  backgroundImage={project.backgroundImage}
                  backgroundImage2={project.backgroundImage2}
                  projectLink={project.projectLink}
                  className="hover:shadow-xl"
                />
              ))}
            </Suspense>
          )}
        </div>
        <Button
          color="white_A700"
          size="lg"
          rightIcon={
            <Img
              src="images/arrow-up-right.png"
              alt="Arrow Icon"
              className="h-8 w-8 transition-all duration-300 group-hover:invert"
            />
          }
          className="w-[99%] 2xl:w-[80%] mt-4 sm:mt-0 sm:mb-4 rounded-[30px] font-medium text-[20px] border-2 border-gray-300 px-8 py-3 uppercase tracking-wide bg-white-a700 text-gray-950 hover:bg-gray-950 hover:text-white-a700 hover:shadow-md group transition-all duration-300"
          onClick={handleViewAllWork}
        >
          View All Work
        </Button>
      </div>
    </div>
  );
}
